import { loginIcon } from "@excalidraw/excalidraw/components/icons";
import { POINTER_EVENTS } from "@excalidraw/common";
import { useI18n } from "@excalidraw/excalidraw/i18n";
import { WelcomeScreen } from "@excalidraw/excalidraw/index";
import React from "react";

import { useAuth } from "../hooks/useAuth";
import { AuthModal } from "./AuthModal";

export const AppWelcomeScreen: React.FC<{
  onCollabDialogOpen: () => any;
  isCollabEnabled: boolean;
}> = React.memo((props) => {
  const { t } = useI18n();
  const { user, token } = useAuth();
  const [showAuthModal, setShowAuthModal] = React.useState(false);

  return (
    <>
      <WelcomeScreen>
        <WelcomeScreen.Hints.MenuHint>
          {t("welcomeScreen.app.menuHint")}
        </WelcomeScreen.Hints.MenuHint>
        <WelcomeScreen.Hints.ToolbarHint />
        <WelcomeScreen.Hints.HelpHint />
        <WelcomeScreen.Center>
          <WelcomeScreen.Center.Logo />
          <WelcomeScreen.Center.Heading>
            {t("welcomeScreen.app.center_heading")}
            <br />
            {t("welcomeScreen.app.center_heading_line2")}
            <br />
            {t("welcomeScreen.app.center_heading_line3")}
          </WelcomeScreen.Center.Heading>
          <WelcomeScreen.Center.Menu>
            <WelcomeScreen.Center.MenuItemLoadScene />
            <WelcomeScreen.Center.MenuItemHelp />
            {props.isCollabEnabled && (
              <WelcomeScreen.Center.MenuItemLiveCollaborationTrigger
                onSelect={() => props.onCollabDialogOpen()}
              />
            )}
            {!user && (
              <WelcomeScreen.Center.MenuItem
                onSelect={() => setShowAuthModal(true)}
                icon={loginIcon}
                shortcut={null}
              >
                {t("auth.login")}
              </WelcomeScreen.Center.MenuItem>
            )}
          </WelcomeScreen.Center.Menu>
        </WelcomeScreen.Center>
      </WelcomeScreen>
      <AuthModal
        isOpen={showAuthModal}
        onClose={() => setShowAuthModal(false)}
        onAuthSuccess={() => window.location.reload()}
        currentUser={user && token ? { ...user, token } : null}
      />
    </>
  );
});